<div [ngClass]="{'border-gray-400 dark:border-gray-600': titleKey, 'border-transparent': !titleKey}"
     class="inline-flex items-center justify-center border border-gray-400 rounded-full px-2 py-0.5 h-6">
    <div *ngIf="color" class="inline-flex flex-0 items-center justify-center w-3 h-3 rounded-full" [ngClass]="{'text-primary-600 bg-primary-400 dark:text-primary-50 dark:bg-primary-600': color === 'primary',
                            'text-accent-600 bg-accent-400 dark:text-accent-50 dark:bg-accent-600': color === 'accent',
                            'text-warn-600 bg-warn-400 dark:text-warn-50 dark:bg-warn-600': color === 'warn',
                            'text-gray-600 bg-gray-400 dark:text-gray-50 dark:bg-gray-600': color === 'basic',
                            'text-blue-600 bg-blue-400 dark:text-blue-50 dark:bg-blue-600': color === 'info',
                            'text-green-500 bg-green-400 dark:text-green-50 dark:bg-green-500': color === 'success',
                            'text-amber-500 bg-amber-400 dark:text-amber-50 dark:bg-amber-500': color === 'warning',
                            'text-red-600 bg-red-400 dark:text-red-50 dark:bg-red-600': color === 'error'
                            }">
    </div>
    <div *ngIf="titleKey"
        [ngClass]="{'ml-1 sm:ml-2': color, 'ml-0': !color}"
        class="inline-flex font-medium text-sm">{{titleKey | transloco}}
    </div>
</div>
